<template>
    <div class="Appall" style="min-width: 1200px;">
        <div class="tp1" style="height: 945px;">
            <div class="tp1_bg">
                <div class="tp1_left"></div>
                <div class="tp1_mid" style="display: flex;">
                    <div class="tp1_mid_left">
                        <div class="tp1_mid_left_1">On Call Care APP</div>
                        <div class="tp1_mid_left_2" style="width: 549px;">Streamline your workflow efficiency, eliminating the need for manual record-keeping, and help you manage diabetes more easily.</div>
                        <div class="tp1_mid_left_3" style="display: flex;">
                            <div class="tp1_mid_left_3_apple">
                                <div class="tp1_mid_left_3_apple_qrcode"><b-img :src="require('@/assets/oncallcareapp_apple.png')" class="tp1icon1" /></div>
                                <div class="tp1_mid_left_3_apple_2"><b-img :src="require('@/assets/oncallcareapp_apple2.png')" class="tp1icon2" /></div>
                            </div>
                            <div class="tp1_mid_left_3_google">
                                <div class="tp1_mid_left_3_google_qrcode"><b-img :src="require('@/assets/oncallcareapp_google.png')" class="tp1icon1" /></div>
                                <div class="tp1_mid_left_3_google_2"><b-img :src="require('@/assets/oncallcareapp_google2.png')" class="tp1icon2" /></div>
                            </div>
                        </div>
                    </div>
                    <div class="tp1_mid_right"><b-img :src="require('@/assets/oncallcareapp_0.png')" class="tp1image_1" /></div>
                </div>
                <div class="tp1_right"></div>
            </div>
        </div>

        <div class="tp4" style="margin-top: -200px;">
          <div class="tp4_left"></div>

        <div class="tp4_midall">
            <div class="tp4_mid_title">Special Features</div>
            <div class="tp4_mid">
                <div class="tp4_mid_1">
                <div class="tp4_mid_1_image"><b-img :src="require('@/assets/oncallcareappicon_1.png')" class="tp3icon1" /></div>
                <div class="tp4_mid_1_title">Digital Management</div>
                <div class="tp4_mid_1_sub">Support manual input and synchronization of blood sugar with a glucometer.</div>
                </div>
                <div class="tp4_mid_2">
                <div class="tp4_mid_2_image"><b-img :src="require('@/assets/oncallcareappicon_2.png')" class="tp3icon2" /></div>
                <div class="tp4_mid_2_title">Report Export</div>
                <div class="tp4_mid_2_sub">Review historical blood sugar information, and export reports in various formats.</div>
                </div>
                <div class="tp4_mid_3">
                <div class="tp4_mid_3_image"><b-img :src="require('@/assets/oncallcareappicon_3.png')" class="tp3icon3" /></div>
                <div class="tp4_mid_3_title">Professional Management of Care Team</div>
                <div class="tp4_mid_3_sub">Join the care team for professional management of patients' blood sugar.</div>
                </div>
            </div>
        </div>

          <div class="tp4_right"></div>
        </div>
        <div class="tp5">
            <div class="tp5_left"></div>
            <div class="tp5_midall">
                <div class="tp5_midtitle">Core Features</div>
                <div class="tp5_mid" style="display: flex;">
                    <div class="tp5_mid_left">
                        <div class="tp5_mid_left_1">Display The Latest Data and Trends Of Health Projects Over The Past 7 Days.</div>
                        <div class="tp5_mid_left_2">Display the latest blood glucose, blood pressure, weight, and blood oxygen data, as well as trends over the past 7 days.</div>
                    </div>
                    <div class="tp5_mid_right"><b-img :src="require('@/assets/oncallcareapp_1.png')" class="tp5image_1" /></div>
                </div>
            </div>
            <div class="tp5_right"></div>
        </div>

        <div class="tp6">
            <div class="tp6_left"></div>
            <div class="tp6_midall">
                <div class="tp6_mid" style="display: flex;">
                    <div class="tp6_mid_left">
                        <b-img :src="require('@/assets/oncallcareapp_2.png')" class="tp6image_1" />
                    </div>
                    <div class="tp6_mid_right" style="margin-top: 180px; margin-left: -59px;">
                        <div class="tp6_mid_right_1">Record Daily Data and View Historical Trends.</div>
                        <div class="tp6_mid_right_2">Input or synchronize blood glucose, blood pressure, weight, and daily diet from your glucometer, track blood glucose trends, and view pre- and post-meal blood glucose comparison charts.</div>
                    </div>
                </div>
            </div>
            <div class="tp6_right"></div>
        </div>

        <div class="tp7">
            <div class="tp7_left"></div>
            <div class="tp7_midall">
                <div class="tp7_mid" style="display: flex;">
                    <div class="tp7_mid_left">
                        <div class="tp7_mid_left_1">Based On Historical Blood Glucose Data, You Can Export Reports.</div>
                        <div class="tp7_mid_left_2">Display historical data in two ways: timeline and list, and export health reports in various formats.</div>
                    </div>
                    <div class="tp7_mid_right" style="left: 154px;"><b-img :src="require('@/assets/oncallcareapp_3.png')" class="tp7image_1" /></div>
                </div>
            </div>
            <div class="tp7_right"></div>
        </div>

        <div class="tp8" style="margin-top: -240px;">
            <div class="tp8_left"></div>
            <div class="tp8_midall">
                <div class="tp8_mid" style="display: flex;">
                    <div class="tp8_mid_left">
                        <b-img :src="require('@/assets/oncallcareapp_4.png')" class="tp8image_1" style="margin-left: -122px;" />
                    </div>
                    <div class="tp8_mid_right" style="margin-top: 323px; margin-left: -73px;">
                        <div class="tp8_mid_right_1">Join The Care Team For Professional Management Of Personal Health.</div>
                        <div class="tp8_mid_right_2">Join the medical team to link with your doctor and manage your blood sugar with personalized continuity.</div>
                    </div>
                </div>
            </div>
            <div class="tp8_right"></div>
        </div>

    </div>
  </template>
  
  <script>
  export default {
    name: 'OnCallCareAppPage',
    mounted() {
  },
  }
  </script>
  
  <style scoped>
  .outall{
    min-width: 1400px;
  }
  .tp1{
    background: linear-gradient(159.78deg, #D1E7FE 18.1%, #FFFFFF 63.52%);
  }
  .tp1_bg{
    display: grid;
    grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
    gap: 0; /* 去掉列间距 */
    margin-bottom: 120px;
  }
  .tp1_mid_left_1{
    font-family: Arial;
font-size: 56px;
font-weight: 700;
line-height: 64px;
color: #14315E;
margin-top: 124px;
margin-bottom: 16px;
  }
  .tp1_mid_left_2{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 24px;
color: #555555;
margin-bottom: 60px;
  }
  .tp1_mid_left_3_apple{
    margin-right: 5px;
  }
  .tp1_mid_left_3_apple,
  .tp1_mid_left_3_google {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .tp1icon2{
    margin-top: -24px;
  }
  .tp4_mid_title{
    text-align: center;
    font-family: Arial;
    font-size: 36px;
    font-weight: 700;
    line-height: 44px;
    color: #000000;
    margin-bottom: 32px;
  }
  .tp4 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  margin-bottom: 120px;
}

.tp4_left,
.tp4_right {

}

.tp4_mid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 将中间部分均等划分为四列 */
  gap: 20px; /* 设置每列之间的间距 */
}

.tp4_mid_1,
.tp4_mid_2,
.tp4_mid_3,
.tp4_mid_4 {
  padding: 20px; /* 添加内边距 */
  display: flex;
  flex-direction: column;
  align-items: center; /* 子元素在垂直方向上居中 */
  justify-content: flex-start; /* 子元素在水平方向上对齐起始位置 */
}

.tp4_mid_1_image,
.tp4_mid_2_image,
.tp4_mid_3_image,
.tp4_mid_4_image {
  display: flex;
  justify-content: center; /* 水平方向居中 */
  align-items: center; /* 垂直方向居中 */
  width: 100%; /* 确保容器宽度为100% */
}

.tp3icon1,
.tp3icon2,
.tp3icon3 {
  width: 56px; /* 图像宽度 */
  height: auto;
}

.tp4_mid_1_title,
.tp4_mid_2_title,
.tp4_mid_3_title,
.tp4_mid_4_title {
  font-family: Arial;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #333333;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.tp4_mid_1_sub,
.tp4_mid_2_sub,
.tp4_mid_3_sub {
  display: flex;
  align-items: center;

  width: 100%; /* 确保容器宽度为100% */
  text-align: center; 
  flex-direction: column; /* 垂直排布 */
  color: #666666;
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
}
.tp5,
.tp6,
.tp7,
.tp8 {
    display: grid;
    grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
    gap: 0; /* 去掉列间距 */
    margin-bottom: 120px;
}
.tp5_midtitle{
    text-align: center;
    font-family: Arial;
    font-size: 36px;
    font-weight: 700;
    line-height: 44px;
    color: #000000;
  }
  .tp5_mid_left{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: -178px;
  }
  .tp5_mid_left_1,
  .tp6_mid_right_1,
  .tp7_mid_left_1,
  .tp8_mid_right_1 {
    width: 353px;
    font-family: Arial;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    color: #000000;
    margin-bottom: 32px;
  }
  .tp5_mid_left_2,
  .tp6_mid_right_2,
  .tp7_mid_left_2,
  .tp8_mid_right_2 {
    width: 384px;
    font-family: Arial;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    color: #555555;
  }
  .tp7_mid {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tp7_mid_left {
    width: 462px;
    position: absolute;
    z-index: 2;
    margin-left: -619px;
}

.tp7_mid_right {
    max-width: 100%;
    position: relative;
    z-index: 1;
}

.tp7image_1 {
    width: 100%;
}
  </style>